import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'
import MeetingReducer from './MeetingReducer'
import CallReducer from './CallReducer'
import MainInfosReducer from './MainInfosReducer'
import FeedBackFormReducer from './FeedBackFormReducer'
import TransmissionReduceer from './TransmissionReducer'
import NetConnectivityReducer from './NetConnectivityReducer'
import ConformityReducer from './ConformityReducer'
import HistoryReducer from './HistoryReducer'
import FeedbackDialogReducer from './FeedbackDialogReducer'
import MainReducer from './MainReducer'
import ThemeReducer from './ThemeReducer'
import DemoModeReducer from './DemoModeReducer'
import ActModuleReducer from './ActModuleReducer'

export default combineReducers({
    auth: AuthReducer,
    meetings: MeetingReducer,
    call: CallReducer,
    mainInfos: MainInfosReducer,
    feedbackform: FeedBackFormReducer,
    transmission: TransmissionReduceer,
    netConnectivity: NetConnectivityReducer,
    conformity: ConformityReducer,
    history: HistoryReducer,
    feedbackDialogReducer: FeedbackDialogReducer,
    main: MainReducer,
    theme: ThemeReducer,
    demoMode: DemoModeReducer,
    actModule: ActModuleReducer,
})
